import { render } from "./FormatInput.vue?vue&type=template&id=65e9dcc7&scoped=true&ts=true"
import script from "./FormatInput.vue?vue&type=script&lang=ts"
export * from "./FormatInput.vue?vue&type=script&lang=ts"

import "./FormatInput.vue?vue&type=style&index=0&id=65e9dcc7&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e9dcc7"]])

export default __exports__